import { render, staticRenderFns } from "./CodeBlockWrapper.vue?vue&type=template&id=399bb7d2&scoped=true&lang=pug"
import script from "./CodeBlockWrapper.vue?vue&type=script&lang=ts"
export * from "./CodeBlockWrapper.vue?vue&type=script&lang=ts"
import style0 from "./CodeBlockWrapper.vue?vue&type=style&index=0&id=399bb7d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399bb7d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VIcon,VTooltip})
